<script>
  import { onMount, onDestroy } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';
  import Events from '../lib/events.js';
  import APIClient from '../state-charts/api-client';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import session from '../lib/session';

  export let user;

  let team_name;
  let team_code;
  let dialog;
  let btn_disabled = true;

  let wait_api = false;
  let add_label = t9n(TS.ORDERER_TEAMS_ADD_LABEL);
  let close_label = t9n(TS.ORDERER_TEAMS_CLOSE_LABEL);
  let add_team_title = t9n(TS.ORDERER_TEAMS_ADD_TEAM_TITLE);
  let team_name_title = t9n(TS.ORDERER_TEAMS_TEAM_NAME_TITLE);
  let team_code_title = t9n(TS.ORDERER_TEAMS_TEAM_CODE_TITLE);

  $: team_code_tooltip = t9n(
    $session.user.last_role === 'worker'
      ? t9n(TS.TOOLTIPS_TEAM_CODE_WORKER)
      : t9n(TS.TOOLTIPS_TEAM_CODE)
  );

  const add_team = async () => {
    wait_api = true;
    wait_for_sec(2000)
    const data = {
      name: team_name,
      code: team_code,
      orderer_id: user.id,
    };

    let result = await APIClient.add_team(data);
    wait_api = false;
    if (!!result) {
      Events.dispatch('ordererteamadded', { team: data.team });
      dialog.close();
    }
  };

  const wait_for_sec = (sec) => {
    wait_api = true;
     setTimeout(function() {
      wait_api = false;
    }, sec);
  }

  const is_code_valid = code => {
    if (!code) return false;
    const length = code.length;
    if ($session.user.last_role === 'worker') {
      return length >= 5 && length <= 10;
    }
    return length === 5;
  };

  const validate_fields = (name, code) => {
    btn_disabled = !(!!name && name.length > 0 && is_code_valid(code));
  };

  $: validate_fields(team_name, team_code)

  onMount(async () => {
    dialog = new MDCDialog(document.querySelector('#add_team_dialog'));
    dialog.open();
  });

  onDestroy(() => {
    dialog = null;
  });
</script>

<div id="add_team_dialog" class="mdc-dialog">
  <div class="mdc-dialog__container">
    <div
      class="mdc-dialog__surface"
      role="dialog"
      aria-modal="true"
      aria-labelledby="add_team_dialog_title"
      aria-describedby="add-team-dialog-content">
      <h2
        class="mdc-dialog__title"
        style="text-align: center; margin-top: 15px"
        id="add_team_dialog_title">
        {add_team_title}
      </h2>

      <div
        class="mdc-dialog__content"
        style="padding: 15px 40px; text-align:center"
        id="add_team_dialog_content">
        <div>
          <InputWithValidation
            id="team-name-field"
            type='text'
            margin_bottom={'16px'}
            is_required={true}
            label={team_name_title}
            name="search-field"
            bind:value={team_name} />
        </div>

        <div data-tooltip={team_code_tooltip}>
          <InputWithValidation
            id="team-code-field"
            type='text'
            margin_bottom={'16px'}
            is_required={true}
            label={team_code_title}
            name="search-field"
            bind:value={team_code} />
        </div>


      </div>
      <p class='required'>* {t9n(TS.REQUIRED_LABEL)}</p>

      <footer class="mdc-dialog__actions">
        <button
          id="add_team_close_button"
          style='margin-right: 10px;'
          on:click|stopPropagation|preventDefault={() => dialog.close()}
          class="btn-close mdc-button mdc-button--unelevated">
          <span class="mdc-button__ripple" />
          {close_label}
        </button>

        <button
          disabled={wait_api || btn_disabled}
          id="add_team_add_button"
          class="mdc-button mdc-button--unelevated"
          on:click|stopPropagation|preventDefault={async () => { await add_team() } }>
          {add_label}
        </button>
      </footer>
    </div>
  </div>

  <div class="mdc-dialog__scrim" />
</div>

<!-- Hidden confirm dialog -->
<div id="confirm-add" />

<style>
    .required{
        font-size: 10pt;
        margin-left: 45px;
        margin-top: -10px;
        color: #323232;
    }
</style>
